export default {
  aiAssistant: {
    greeting: "您好！我是智能助手小圖。",
  },
  messages: {
    sessionExpired: "登入過期請重新登入",
  },
};
